import { g as y } from "./javascript.esm-BbdhFZbf.js";
import { a as L, i as S, t as W } from "./toNumber-CX_AIqYr.js";
import { f as d } from "./FormErrorMessage-C4ydi9Qu-D0_4CrD9.js";
import { memo as C } from "react";
var F = L, N = function() {
  return F.Date.now();
}, O = N, z = S, b = O, I = W, A = "Expected a function", B = Math.max, D = Math.min;
function $(r, n, t) {
  var o, s, v, u, i, a, c = 0, T = !1, f = !1, h = !0;
  if (typeof r != "function")
    throw new TypeError(A);
  n = I(n) || 0, z(t) && (T = !!t.leading, f = "maxWait" in t, v = f ? B(I(t.maxWait) || 0, n) : v, h = "trailing" in t ? !!t.trailing : h);
  function x(e) {
    var l = o, m = s;
    return o = s = void 0, c = e, u = r.apply(m, l), u;
  }
  function R(e) {
    return c = e, i = setTimeout(g, n), T ? x(e) : u;
  }
  function _(e) {
    var l = e - a, m = e - c, E = n - l;
    return f ? D(E, v - m) : E;
  }
  function w(e) {
    var l = e - a, m = e - c;
    return a === void 0 || l >= n || l < 0 || f && m >= v;
  }
  function g() {
    var e = b();
    if (w(e))
      return j(e);
    i = setTimeout(g, _(e));
  }
  function j(e) {
    return i = void 0, h && o ? x(e) : (o = s = void 0, u);
  }
  function k() {
    i !== void 0 && clearTimeout(i), c = 0, o = a = s = i = void 0;
  }
  function M() {
    return i === void 0 ? u : j(b());
  }
  function p() {
    var e = b(), l = w(e);
    if (o = arguments, s = this, a = e, l) {
      if (i === void 0)
        return R(a);
      if (f)
        return clearTimeout(i), i = setTimeout(g, n), x(a);
    }
    return i === void 0 && (i = setTimeout(g, n)), u;
  }
  return p.cancel = k, p.flush = M, p;
}
var U = $;
const P = /* @__PURE__ */ y(U), X = ({
  title: r,
  titleId: n,
  ...t
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": n,
    ...t,
    children: [
      r ? /* @__PURE__ */ d.jsx("title", { id: n, children: r }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M510.955 872.555c-12.267 0-24.683-.619-36.885-1.856-23.445-2.368-40.533-23.317-38.187-46.741 2.389-23.445 23.275-40.533 46.763-38.165 9.365.96 18.901 1.429 28.309 1.429 152.363 0 276.288-123.947 276.288-276.267 0-152.363-123.925-276.288-276.288-276.288S234.667 358.592 234.667 510.955c0 27.648 4.053 54.912 12.053 81.045 6.891 22.528-5.76 46.379-28.288 53.291-22.507 6.891-46.4-5.76-53.291-28.288-10.496-34.261-15.808-69.931-15.808-106.048 0-199.403 162.219-361.621 361.621-361.621s361.621 162.219 361.621 361.621c0 199.381-162.219 361.6-361.621 361.6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Q = C(X), q = ({
  title: r,
  titleId: n,
  ...t
}) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": n,
    ...t,
    children: [
      r ? /* @__PURE__ */ d.jsx("title", { id: n, children: r }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M265.094 540.081c-78.507-78.507-78.507-206.229 0-284.736 38.016-38.037 88.576-58.965 142.357-58.965s104.32 20.949 142.379 58.965c78.485 78.507 78.485 206.229 0 284.736-38.059 38.016-88.597 58.987-142.379 58.987s-104.341-20.971-142.357-58.987m567.915 225.685L636.657 569.393c37.099-49.301 57.472-108.864 57.472-171.691 0-76.565-29.824-148.544-83.968-202.688s-126.123-83.968-202.709-83.968c-76.565 0-148.565 29.824-202.688 83.968-54.144 54.144-83.968 126.123-83.968 202.688 0 76.587 29.824 148.565 83.968 202.709 54.123 54.144 126.123 83.989 202.688 83.989 61.461 0 119.765-19.499 168.448-55.083l196.779 196.779c8.341 8.341 19.243 12.501 30.165 12.501s21.824-4.16 30.165-12.501c16.661-16.661 16.661-43.669 0-60.331z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), V = C(q);
export {
  P as d,
  V as n,
  Q as t
};
